module.exports = __webpack_public_path__ + "static/img/47010.7961804.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/47010.jpg
// module id = fXOW
// module chunks = 1